/**
 * Group dividend rows the same way legacy TVChart does before setMarkersData.
 */
export default function processTvChartDividends(dividends = []) {
  const processedDividends = [];

  (dividends || []).forEach(dividend => {
    const processedDividendIndex = processedDividends.findIndex(
      processedDividend =>
        processedDividend.dividend_day === dividend.dividend_day
    );

    if (processedDividendIndex === -1) {
      processedDividends.push({
        ...dividend,
        payouts: [
          {
            day: dividend.payout_day,
            payout: dividend.payout
          }
        ]
      });
      return;
    }

    processedDividends[processedDividendIndex].has_multiple_payouts = true;
    processedDividends[processedDividendIndex].payouts.push({
      day: dividend.payout_day,
      payout: dividend.payout
    });
  });

  return processedDividends;
}
